import React from "react";

export const WarningMessageForProduction: React.FC<{
  isEdit: boolean;
}> = ({ isEdit }) => {
  const action = isEdit ? "更新" : "作成";

  return (
    <div
      style={{
        color: "#ff3300",
        fontWeight: "600",
      }}
    >
      <div>{`Production環境のフロントエンドアドオンを${action}しようとしています。`}</div>
      <div>{`本当に${action}しますか？`}</div>
    </div>
  );
};
